'use client';

import { Box } from '@mui/material';
import dynamic from 'next/dynamic';
import Image from 'next/image';

type SocialNetworkIconProps = {
	icon: string;
	url: string;
};

type AssetIconProps = {
	icon: string;
	iconSize: number;
};

const AssetIcon = ({ icon, iconSize }: AssetIconProps) => (
	<Image
		src={icon}
		alt={icon}
		width={iconSize}
		height={iconSize}
		className="lazyload"
		style={{ marginLeft: '4px', marginTop: '3px' }}
	/>
);

export const SocialNetworkIcon = ({ icon, url }: SocialNetworkIconProps) => {
	// If we have new social networks, they need to be added in this object
	const iconMap: Record<string, React.ComponentType<any>> = {
		Instagram: dynamic(() => import('@mui/icons-material/Instagram'), { ssr: false }),
		Twitter: dynamic(() => import('@mui/icons-material/Twitter'), { ssr: false }),
		Facebook: dynamic(() => import('@mui/icons-material/Facebook'), { ssr: false }),
		YouTube: dynamic(() => import('@mui/icons-material/YouTube'), { ssr: false }),
		Pinterest: dynamic(() => import('@mui/icons-material/Pinterest'), { ssr: false }),
	};

	if (icon.includes('https')) {
		return (
			<Box
				sx={{
					backgroundColor: '#fd8331',
					width: 30,
					height: 30,
				}}
			>
				<a rel="noreferrer" target={'_blank'} href={url}>
					<AssetIcon icon={icon} iconSize={24} />
				</a>
			</Box>
		);
	} else {
		const IconComponent = iconMap[icon];

		return (
			<Box
				sx={{
					backgroundColor: '#fd8331',
					width: 30,
					height: 30,
				}}
			>
				<a
					rel="noreferrer"
					target={'_blank'}
					href={url}
					style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center' }}
				>
					<IconComponent sx={{ color: '#fff', alignSelf: 'center', justifySelf: 'center' }} />
				</a>
			</Box>
		);
	}
};
